import { RefreshCw } from 'lucide-react';
import { errorMessage, requestIdOf } from '../api/errors';
import { useI18n } from '../i18n/I18nProvider';
import { Button } from './Button';
import { Callout } from './Feedback';
import { Code } from './Layout';

/** Inline error for a failed read, with the request id and a retry. */
export function QueryError({ error, onRetry }: { error: unknown; onRetry?: () => void }) {
  const { t } = useI18n();
  const requestId = requestIdOf(error);
  return (
    <Callout
      tone="danger"
      role="alert"
      title={errorMessage(t, error)}
      action={
        onRetry ? (
          <Button size="sm" icon={<RefreshCw size={14} aria-hidden="true" />} onPress={onRetry}>
            {t.common.retry}
          </Button>
        ) : undefined
      }
    >
      {requestId ? (
        <span>
          {t.errors.reference}: <Code>{requestId}</Code>
        </span>
      ) : null}
    </Callout>
  );
}
